import { SearchOptions } from '@ryusei/code';


/**
 * The default options for the Search component.
 *
 * @since 0.1.0
 */
export const DEFAULT_OPTIONS: SearchOptions = {
  hideButtons: [],
};
